import React from "react";
import { Organization } from "./api";

export const OrgContext = React.createContext<Organization | "NONE" | null>(null);
export const OrgIdContext = React.createContext("");